import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';
import { formatToDecimal } from '../conversions';
import { formatToFractional } from '../conversions';

const FrameWidth = ({ value, onChange, label = 'Frame Width', doorSizeValue = null, doorHeightValue = null, passSelectedDoor }) => {
    const [selectedFrameWidth, setSelectedFrameWidth] = useState(value || "");
     const [FrameWidthError, setFrameWidthError] = useState("");
     const [minW, setMinW] = useState("");
     const [maxW, setMaxW] = useState("");


     const calcWidth = (doorType, doorSize) => {
        if (doorType === 1) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 1).toString() + ' 1/2"';
        }
        if ([2, 3].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 17).toString() + '"';
        }
        if (doorType === 4) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 32).toString() + ' 1/2"';
        }
        if (doorType === 5) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2).toString() + '"';
        }
        if ([6, 7].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 17).toString() + ' 1/2"';
        }
        if (doorType === 8) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2*17 - 1).toString() + '"';
        }
        return 0;
     }
    useEffect(() => {
        if (passSelectedDoor) {
            if (passSelectedDoor.id > 4) {
                setMinW(40);
                setMaxW(80);
            }
            else {
                setMinW(24);
                setMaxW(40);
            }
        }
        if (!doorSizeValue) {
            const element = document.getElementById("DoorSize");
            if (element) { 
                doorSizeValue = element.value;
            }
        }
        if (doorHeightValue) {}
        if (passSelectedDoor && doorSizeValue) {
            //alert(JSON.stringify(passSelectedDoor, null, 2));
            const w = calcWidth(passSelectedDoor.id, doorSizeValue);
            setSelectedFrameWidth(w);
            validateFrameWidth(w);
            onChange(w);
        }
      }, [doorSizeValue, doorHeightValue, passSelectedDoor]); // Trigger effect whenever doorSizeValue changes

    const handleFrameWidthChange = (e) => {
        //setSelectedFrameWidth(e.target.value);
        validateFrameWidth(e.target.value);
        onChange(e.target.value);
    };
    const validateFrameWidth = (value) => {
        //const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        const numericValue = value;
        setSelectedFrameWidth(numericValue);

        if (numericValue && (numericValue < minW || numericValue > maxW)) {
            setFrameWidthError(`Door Frame Width must be between ${minW} and ${maxW}`);
        } else {
            setFrameWidthError("");
        }
    };



        
    const handleFocus = (e) => {
      const decimalValue = formatToDecimal(e.target.value);
      setSelectedFrameWidth(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedFrameWidth(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label htmlFor="FrameWidth">{label}</label>
            <input
                id="FrameWidth"
                value={selectedFrameWidth}
                onChange={handleFrameWidthChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {FrameWidthError && <p className="error">{FrameWidthError}</p>}
        </div>
    );
};

export default FrameWidth;